import { Controller } from "@hotwired/stimulus"

// A Watching card turned over to its back (every store's price, its hang
// tag) and back again: a quarter turn out, the other side, a quarter turn
// in. Flip back lands where the flip button was, so the pointer needn't move.
export default class extends Controller {
  static targets = ["front", "back"]

  flip(event) {
    event.preventDefault()
    const card = this.element
    const toBack = !card.classList.contains("is-back")
    if (toBack && this.hasFrontTarget && this.hasBackTarget) {
      const c = card.getBoundingClientRect(), b = this.frontTarget.getBoundingClientRect(), edge = card.clientLeft
      this.backTarget.style.top = `${b.top - c.top - edge}px`
      this.backTarget.style.right = `${c.right - b.right - edge}px`
      this.backTarget.style.bottom = "auto"
    }
    const turn = () => {
      card.classList.toggle("is-back", toBack)
      ;(toBack ? this.backTarget : this.frontTarget)?.focus({ preventScroll: true })
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return turn()
    card.classList.add("is-turning")
    setTimeout(() => { turn(); card.classList.remove("is-turning") }, 160)
  }
}
